import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/fms/fms_driver_additional_fees`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

 
function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_driver_additional_fees/${id}`, options)
    .then(response => {
      let driver_additional_fee = jsona.deserialize(response.data);
      delete driver_additional_fee.links;
      return driver_additional_fee;
    });
}

function add(driver_additional_fee) {
  
  console.log(driver_additional_fee);
  const payload = jsona.serialize({
    stuff: driver_additional_fee,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/fms/fms_driver_additional_fees`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(driver_additional_fee) {
  const payload = jsona.serialize({
    stuff: driver_additional_fee,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };
 
  return axios.patch(`${url}/fms/fms_driver_additional_fees/${driver_additional_fee.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/fms/fms_driver_additional_fees/${id}`, options);
}

function last_no() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_driver_additional_fees/last/no`, options)
    .then(response => {
      return response.data;
    });
}

function update_status(driver_additional_fee) {
  const payload = jsona.serialize({
    stuff: driver_additional_fee,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/fms/fms_driver_additional_fees/update_status/${driver_additional_fee.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}


export default {
  list,
  get,
  add,
  update,
  destroy,
  last_no,
  update_status,
};

